module.exports = __webpack_public_path__ + "img/cspace-firetvstore.17792fa9.svg";